import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Dialog } from '@progress/kendo-react-dialogs'
import { reduceString } from 'utils/string'
import { Typography, Box } from '@mui/material'
import { Loader } from '@progress/kendo-react-indicators'
import CustomButton from 'components/Common/Button';
import { PRIMARY_BUTTON } from 'themes/theme';
import { VaultAPI } from 'api'

const VaultDocumentPreviewPopup = ({ document, onClose, width = '900px', height = '600px', vault_id }) => {
  const [txtFileContent, updateTxtFileContent] = useState();
  const dispatch = useDispatch()


  const formattedTitle = reduceString(document.article_name, 60)

  useEffect(() => {
    if (document.article_type === 'txt') {
      !txtFileContent && VaultAPI.fetchDocuments(dispatch, vault_id)
      fetch(document.file_url)
        .then(response => response.text())
        .then(data => {
          updateTxtFileContent(data);
        });
    }
  }, [document, dispatch, txtFileContent, vault_id])


  if (['PDF', 'pdf', 'PNG', 'png', 'JPEG', 'jpeg', 'JPG', 'jpg', 'TXT', 'txt'].indexOf(document.article_type) === -1) {
    return (
      <Dialog width={width} height="100%">
        <Box fontSize='24px' fontWeight={600} textAlign='center' marginY='20px'>
          {formattedTitle}
        </Box>
        <Box height='70%' sx={{ overflowY: 'auto' }}>
          <div className="k-d-flex k-justify-content-center k-align-items-center h-full">
            <h4 className="color-primary k-text-center">
              Sorry, but we don't support this file type for preview. Only download available{' '}
              <a
                download
                target="_blank"
                rel="noopener noreferrer"
                href={document.file_url}
                className="color-secondary k-cursor-pointer"
              >
                here
              </a>
              .
            </h4>
          </div>
        </Box>
        <Box textAlign='center' marginY='20px'>
          <CustomButton className='px-5' onClick={onClose} type={PRIMARY_BUTTON}>
            Close
          </CustomButton>
        </Box>
      </Dialog>
    )
  } else {
    return (
      <Dialog
        width={width}
        height={height}
      >
        <Box fontSize='24px' fontWeight={600} textAlign='center' marginY='20px'>
          {formattedTitle}
        </Box>
        <Box height='70%' sx={{ overflowY: 'auto' }}>
          {document.article_type === 'pdf' && (
            <object
              aria-label="Document preview"
              data={document.file_url}
              type="application/pdf"
              style={{ width: '100%', height: '98%' }}
            >
              <div>No online PDF viewer installed</div>
            </object>
          )}
          {['PNG', 'png', 'JPEG', 'jpeg', 'JPG', 'jpg'].indexOf(document.article_type) !== -1 && (
            <img alt="Document preview" width="100%" src={document.file_url} />
          )}
          {
            document.article_type === 'txt' && (
              txtFileContent
                ? <Typography variant='body2' style={{ whiteSpace: 'pre-line' }}>
                  {txtFileContent}
                </Typography>
                : <Box textAlign='center'><Loader type="converging-spinner" /></Box>
            )
          }
        </Box>
        <Box textAlign='center' marginY='20px'>
          <CustomButton className='px-5' onClick={onClose} type={PRIMARY_BUTTON}>
            Close
          </CustomButton>
        </Box>
      </Dialog>
    )
  }
}

export default VaultDocumentPreviewPopup
